export default {
  'order.tab.require_allocate_stock': 'Require Allocate Stock',
  'order.tab.require_allocate_stock_tooltips': 'Require Allocate Stock',
  'order.tab.allocated_stock': 'Allocated Stock',
  'order.tab.allocated_stock_tooltips': 'Allocated Stock',
  'order.tab.interface_pack_stock': 'Packed, Ready to Ship (Feedback)',
  'order.tab.interface_cancel_stock': 'Exception / Cancel (Feedback)',
  'order.tab.require_ship_stock': 'Require Ship',
  'order.tab.cancelled_by_platform': 'Cancelled By Platform',
  'interface.order.request_name': 'External WMS Status',
  'fulfillment.order.allocate_stock_error': 'Allocate - Stock Error',
  'fulfillment.order.allocate_stock_status': 'Allocate - Stock Status',
  'fulfillment.order.shipped_stock_error': 'Shipped - Stock Error',
  'fulfillment.order.shipped_stock_status': 'Shipped - Stock Status',
  'fulfillment.action-msg.allocate-stock-success': 'Allocated OMS Stock Success',
  'fulfillment.action-msg.pack-stock-success': 'Packed OMS Stock Success',
  'fulfillment.action-msg.cancel-stock-success': 'Cancel Stock Success',
  'fulfillment.action-msg.send-to-sap-success': 'Send To SAP Success',
};
